module.exports = __webpack_public_path__ + "img/symbol_3.5b3401e1.png";